import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class MatchingInvoiceDTO  {
    _originalTypeClassName = "zERP.BO.MatchingInvoiceDTO";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
MatchingInvoiceDTO.translate = translateService;
}
this.Action = null;
this.MatchingInvoiceDTOKey = null;
this._key = this.MatchingInvoiceDTOKey = 0; 
}

static translate: TranslateService;
_key: any;
Action:any;
Invoice:any;
MatchingInvoice:any;
private _MatchingInvoiceDTOKey:any;
get MatchingInvoiceDTOKey(): any {
    return this._MatchingInvoiceDTOKey;
  }
set MatchingInvoiceDTOKey(value: any) {
    this._MatchingInvoiceDTOKey = value;
    this._key = value;
  }
static setInvoice = ($this, value) => {
var oldValue = $this.Invoice;
$this.Invoice = value;
if (value != null) {
}
}
static setMatchingInvoice = ($this, value) => {
var oldValue = $this.MatchingInvoice;
$this.MatchingInvoice = value;
if (value != null) {
}
}


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.MatchingInvoiceDTOKey == null || $this.MatchingInvoiceDTOKey == 0;
            }


}